import Vue from 'vue';
import VueCodeHighlight from 'vue-code-highlight';

Vue.use(VueCodeHighlight); // registers the v-highlight directive
